import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Aluguer de Barco no Algarve · Iate Privado Tripulado · Morningstar";
const DESC =
  "Aluguer de barco no Algarve no Morningstar — iate privado de 200 m² totalmente tripulado a partir da Marina de Vilamoura, até 18 pessoas. Tudo incluído.";
const PATH = "/pt/aluguer-de-barco-algarve";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.boatHireAlgarve;

export const Route = createFileRoute("/pt/aluguer-de-barco-algarve")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: CONTENT.pt.eyebrow,
        title: "Aluguer de barco no Algarve no ",
        titleAccent: "Morningstar.",
        sub: "Iate privado tripulado de 200 m² da Marina de Vilamoura, até 18 pessoas. Tudo incluído — tripulação, combustível, bebidas, tapas portuguesas. Sem necessidade de carta.",
        ctaPrimary: "Ver opções",
        ctaSecondary: "Pedir orçamento",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "aluguer de barco algarve, aluguer barco algarve, alugar barco algarve, aluguer iate algarve",
      altPath: { en: "/boat-hire-algarve", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Aluguer de Barco no Algarve",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Aluguer de Barco Algarve", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});